import { render, staticRenderFns } from "./TaskFilesDisplay.vue?vue&type=template&id=03e98a80&scoped=true&"
import script from "./TaskFilesDisplay.vue?vue&type=script&lang=js&"
export * from "./TaskFilesDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TaskFilesDisplay.vue?vue&type=style&index=0&id=03e98a80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e98a80",
  null
  
)

export default component.exports